import * as Sentry from '@sentry/react'

// DPO-2977: o tradutor automático do navegador (Edge, Chrome) troca os nós de texto da página por
// elementos próprios. Quando o React depois remove ou insere um nó que o tradutor já moveu, o
// navegador lança `NotFoundError` (removeChild/insertBefore) e a árvore inteira cai no ErrorBoundary —
// foi o que o fornecedor estrangeiro viu na jornada do portal. Contorno conhecido de
// facebook/react#11538: tolerar o nó que mudou de pai, em vez de lançar. Para nó com o pai correto,
// o comportamento é o nativo.
const WARNING_PREFIX = '[patchDomForTranslators]'

// O desvio vale para o app inteiro, então também engoliria erro real de DOM de outra lib. Para não
// perder esse sinal, cada operação é reportada ao Sentry uma vez por carregamento de página.
const reportedOperations = new Set()

const reportIgnoredOperation = (operation, parentNode, node) => {
  console.warn(
    `${WARNING_PREFIX} ${operation} ignorado: o nó não é filho deste pai`,
    node?.nodeName,
    parentNode?.nodeName,
  )

  if (reportedOperations.has(operation)) return
  reportedOperations.add(operation)

  Sentry.captureMessage(`${WARNING_PREFIX} ${operation} ignorado`, {
    level: 'warning',
    tags: { 'dom-patch': operation },
    extra: { nodeName: node?.nodeName, parentNodeName: parentNode?.nodeName },
  })
}

if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild
  const originalInsertBefore = Node.prototype.insertBefore

  Node.prototype.removeChild = function removeChild(child) {
    if (child.parentNode !== this) {
      reportIgnoredOperation('removeChild', this, child)
      return child
    }

    return originalRemoveChild.apply(this, arguments)
  }

  Node.prototype.insertBefore = function insertBefore(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      reportIgnoredOperation('insertBefore', this, referenceNode)
      return newNode
    }

    return originalInsertBefore.apply(this, arguments)
  }
}
